import { Box } from "@mui/material"

import { selectUserId } from "../../app/data/appTokensStore"
import { useAppSelector } from "../../app/hooks"
import { useGetAllEvents } from "../fid/hooks/useGetAllEvents"

import FavoritePage from "../../components/favorite_page"
import LocationSpinner from "@/common/ui-kit/spinner"

import { favoriteEventCards } from "./favoriteStyles"
import s from "./styles.module.css"

const Favorite = () => {
  const credentials = useAppSelector(selectUserId)
  const { isLoading } = useGetAllEvents()

if (isLoading)
    return (
      <div
        style={{
          minWidth: "calc(100vw - 16px)",
          textAlign: "center",
          margin: "auto"
        }}
      >
        <LocationSpinner />
      </div>
    )
  return (
    <div className={s.main}>
      <h1 className={s.header}>Избранное</h1>
      <Box sx={favoriteEventCards}>
        <FavoritePage userId={credentials?.toString()!!} />
      </Box>
    </div>
  )
}

export default Favorite
